/** localStorage key that unlocks /sign-in and /register before launch. Any value counts. */
export const AUTH_PREVIEW_KEY = 'wh:auth-preview';

/** ?preview=on saves the unlock flag and ?preview=off clears it. */
export const PREVIEW_PARAM = 'preview';

export type PreviewStorage = Pick<Storage, 'getItem' | 'setItem' | 'removeItem'>;

/** window.localStorage, or undefined where reading it throws (blocked storage, some private modes). */
export const windowStorage = (): PreviewStorage | undefined => {
  try {
    return window.localStorage;
  } catch {
    return undefined;
  }
};

/** Saves or clears the flag for ?preview=on or ?preview=off; anything else changes nothing. Never throws. */
export const applyPreviewParam = (value: string | null, storage: PreviewStorage | undefined): void => {
  try {
    if (value === 'on') {
      storage?.setItem(AUTH_PREVIEW_KEY, 'on');
    } else if (value === 'off') {
      storage?.removeItem(AUTH_PREVIEW_KEY);
    }
  } catch {
    // Storage is full or blocked: the flag stays as it was, and a failed read below counts as missing.
  }
};

/** Whether the flag is saved. Missing when storage is unavailable or throws. */
export const hasAuthPreview = (storage: PreviewStorage | undefined): boolean => {
  try {
    return storage?.getItem(AUTH_PREVIEW_KEY) != null;
  } catch {
    return false;
  }
};
